import { render, staticRenderFns } from "./TaskSelectChoiceCard.vue?vue&type=template&id=6dd1ac76&scoped=true&"
import script from "./TaskSelectChoiceCard.vue?vue&type=script&lang=ts&"
export * from "./TaskSelectChoiceCard.vue?vue&type=script&lang=ts&"
import style0 from "./TaskSelectChoiceCard.vue?vue&type=style&index=0&id=6dd1ac76&prod&lang=css&"
import style1 from "./TaskSelectChoiceCard.vue?vue&type=style&index=1&id=6dd1ac76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd1ac76",
  null
  
)

export default component.exports